import React from 'react'
import { AppLogoProps } from './types'

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

const svgPath =
  'M1.5 10a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .5-.5zM8.5 7a.5.5 0 0 1 .5.5v9a.5.5 0 0 ' +
  '1-1 0v-9a.5.5 0 0 1 .5-.5zM15.5 12a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8a.5.5 0 0 1 .5-.5zM22.5 ' +
  '7a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 .5-.5z'

const AppLogo: React.SFC<AppLogoProps & SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <defs>
        <clipPath id="AppLogo_a">
          <path d="M0 0h24v24H0z"/>
        </clipPath>
      </defs>
      <g clipPath="url(#AppLogo_a)">
        <path d={svgPath} />
      </g>
    </SvgIcon>
  )
}

export default AppLogo
